import React from "react";
import { shallowEqual, useSelector } from 'react-redux'

import { WheelsDaddy } from '../results/wheels-daddy.jsx';
import { Localize } from "../shared/localize.js";
import { parseUrl, joinUrl } from "./wheel-urls.js";

const WheelsPromotedList = (props) => {
  const car = useSelector(state => state.cars.selectedCar) || {};
  const wheels = useSelector(state => state.cars.selectedCarWheels);
  const carLabels = useSelector(state => state.cars.selectedCarLabels);
  const makerModelYear = useSelector(state => state.cars.makerModelYear, shallowEqual);
  const diameters = useSelector(state => state.cars.selectedCarDiameters);

  if (wheels && (wheels.length > 0)) {
    var _wheels = [].concat.apply([], wheels.map(m => { m.Wheels.forEach(e => { e.SpecialLabel = m.Labels[0]; e.Car = m.Car; }); return m.Wheels; }));  
    
    var maker = car.maker;
    var model = car.model;

    var paramsUrl = parseUrl() || {};

    var diameter = paramsUrl.diameters;
    if (diameter && !diameters.some(s => s.Key == diameter) && paramsUrl) {
      paramsUrl.diameters = null;

      document.location.href = joinUrl(paramsUrl);

      return;
    }

    // dobbiamo recuperari i dati dalla tabella perchè potrebbero arrivare dall'URL

    var makerTitle = "";
    var modelTitle = "";

    if ((paramsUrl.maker || "") != "") {
      var element = makerModelYear.find(f => f.ManufacturerName.toLowerCase() == paramsUrl.maker.toLowerCase());

      if (element != null) {
        makerTitle = element.ManufacturerName;

        if ((paramsUrl.model || "") != "") {
          var elementSub = element.Models.find(f => f.ModelName.toLowerCase() == paramsUrl.model.toLowerCase());

          if (elementSub != null) {
            modelTitle = elementSub.ModelName;
          }
        }
      }
    }

    var title = (<span>{Localize.L("Alcuni cerchi suggeriti")}</span>);

    if (modelTitle != "" && modelTitle != null) {
      modelTitle = Localize.L(modelTitle, { Get: 'models', ManufacturerName: car.maker });
    }

    const labels = window.initCarLabels || carLabels;

    if ((diameter || 0) > 0) {
      if (makerTitle != "") {
        title = (<span>{Localize.L("Alcuni cerchi suggeriti per la tua")} {labels["name"]} {Localize.L("diametro {diameter} pollici").replace("{diameter}", diameter)}</span>);
      }
      else {
        title = (<span>{Localize.L("Alcuni cerchi suggeriti diametro {diameter} pollici").replace("{diameter}", diameter)}</span>);
      }
    }
    else if (makerTitle != "") {
      title = (<span>{Localize.L("Alcuni cerchi suggeriti per la tua")} {labels["name"]}</span>);
    }

    return (
      <div className="col-12 pt-3">
        <div className="promoted-title mb-5">
          {title}
        </div>
        <div className="results-wheels">
          <WheelsDaddy
            year={(car || {}).year}
            car={{
              ManufacturerName: car.maker,
              ModelName: car.model,
              ExtChassis: car.chassisIsSelected ? car.chassis != car.model ? car.chassis : "" : null,
              ExtModelType: car.typeIsSelected ? car.type : null
            }}
            wheels={_wheels}
            hideFilters={true}
            hideLoadMore={true}
            selectedDiameter={diameter || ""}
            iDisplayLength={props.iDisplayLength} />
        </div>
      </div>
    );
  }

  return null;
};

export { WheelsPromotedList };